import React from "react";
import "../style/component/_header.scss";
import { color } from "../constants";
// import { Switch, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { useWindowSize } from "../hooks/useWindowSize";
import CustomDrawer from "./CustomDrawer";
import SocialModal from "./SocialModal";
import Lottie from "lottie-react";
import LottieAnim from "../assets/chat-icon.json";

export default function Header(props) {
  const navigate = useNavigate();

  const { width } = useWindowSize();

  const blogHandler = () => {
    navigate("/blog");
  };

  const homeHandler = () => {
    navigate("/");
  };

  // const resumeHandler = () => {
  //   navigate("/resume");
  // };

  const videoHandler = () => {
    navigate("/video");
  };
  return (
    <div className={props.theme ? "header" : "headerDark"}>
      <div className="innerHeader">
        <div className="left">
          <h4 onClick={homeHandler} style={{ cursor: "pointer", fontSize: 20 }}>
            <span style={{ color }} className="logo-animated">
              ShravanMeena
            </span>
          </h4>
        </div>
        <div className="right">
          <div className="innerRight">
            {/* <h4 onClick={props.home}>Home</h4> */}
            {/* <h4 onClick={props.experties}>Skills</h4> */}
            {/* <h4 onClick={props.project}>projects</h4> */}
            <h4 onClick={homeHandler}>home</h4>
            <h4 onClick={blogHandler}>blogs</h4>
            <h4 onClick={videoHandler}>videos</h4>
            <SocialModal>
              <h4 style={{
                width:45,
                marginTop:8
              }}>
                <Lottie style={{}} animationData={LottieAnim} loop={true} />
              </h4>
            </SocialModal>
            {/* <h4 onClick={resumeHandler}>Resume</h4> */}
            {/* <h4 onClick={props.contact}>contact</h4> */}
            {/* <h4 onClick={props.experience}>
              <Tag color="#f50">industry experience</Tag>
            </h4> */}

            {/* <h4>
              <Switch
                // style={{ marginRight: 20 }}
                checkedChildren="Light"
                unCheckedChildren="Dark"
                defaultChecked
                onClick={props.themeChange}
              />

              <Tag color="#f50">industry experience</Tag>
            </h4> */}
          </div>
        </div>
        <div className="end">
          {/* <span className="showLightMode">
            <Switch
              // style={{ marginRight: 20 }}
              checkedChildren="Light"
              unCheckedChildren="Dark"
              defaultChecked
              onClick={props.themeChange}
            />
          </span> */}
          {/* <a href={github} target='_blank'>
          <GithubOutlined />
        </a>
        <a href={linkedin} target='_blank'>
          <LinkedinOutlined />
        </a>
        <a href={medium} target='_blank'>
          <MediumOutlined />
        </a> */}

          {width < 900 ? <CustomDrawer /> : <></>}
        </div>
      </div>
    </div>
  );
}
